var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCosapLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 960 960",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "helix-banner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-1",
    d: "M236.8 348.534a24 24 0 0 1 -13.066 -44.267l238.133 -152.8a24 24 0 1 1 26.666 40.533L249.867 344.534A24 24 0 0 1 236.8 348.534Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-2",
    d: "M353.334 402.933a24 24 0 0 1 -13.066 -44.267L480 268.8a24 24 0 1 1 26.666 40.533L366.4 400A24 24 0 0 1 353.334 402.933Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-3",
    d: "M525.866 806.134a24 24 0 0 1 -13.066 -44.267l238.133 -152.8a24 24 0 0 1 26.666 40.533L538.667 802.4A24 24 0 0 1 525.866 806.134Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-4",
    d: "M504.534 691.734a24 24 0 0 1 -13.066 -44.267l140 -89.867a24 24 0 1 1 26.666 40.267L517.333 688A23.733 23.733 0 0 1 504.534 691.734Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-5",
    d: "M574.933 151.733a95.734 95.734 0 0 1 4 94.133L502.134 400h60l64.8 -129.867a149.6 149.6 0 0 0 -133.333 -217.066H353.6l-26.666 53.334h165.867A96.266 96.266 0 0 1 574.933 151.733Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "clr-i-outline clr-i-outline-path-1",
    d: "M877.6 554.134A147.466 147.466 0 0 0 737.6 453.334H248.267a94.4 94.4 0 0 1 -94.933 -97.867 96.266 96.266 0 0 1 11.2 -41.066l113.6 -226.4a26.666 26.666 0 1 0 -47.733 -24L117.334 289.067A151.2 151.2 0 0 0 106.666 405.866 147.466 147.466 0 0 0 247.466 506.666h202.667l-91.734 183.2a150.4 150.4 0 0 0 40 184.534A143.466 143.466 0 0 0 490.933 906.667h140l26.666 -53.334H491.466a95.466 95.466 0 0 1 -85.867 -138.934L509.6 506.666h227.733a91.2 91.2 0 0 1 57.334 18.933 95.2 95.2 0 0 1 26.666 118.133l-109.867 219.2a26.666 26.666 0 1 0 47.733 24l108.266 -216A151.2 151.2 0 0 0 877.6 554.134Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AB1BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE1E3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosapLogo);
export default __webpack_public_path__ + "static/media/cosap_logo.a13a6873d371c6ffccbb712c39f9333a.svg";
export { ForwardRef as ReactComponent };